<template>
  <article>
    <div class="firstPic leftTextArea">
      <div class="textHolder">
        <h2>Arrangementen</h2>
        <p>
          Geniet van verrassende arrangementen. Wil je graag genieten en
          ontspannen, dan kan je kiezen uit 1 van deze samengestelde pakketten.
        </p>
      </div>
      <img :src="ArrAlgemeen" alt="temp" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Duo arrangementen</h2>
        <p>
          Samengesteld voor jou om samen met je vriendin, zus, mama, … te
          genieten van quality-time in een relaxerende setting.
        </p>
      </div>
      <img :src="duo" alt="duo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Duo Pedicure</h2>
        <ul>
          <li>
            Wellness pedicure met voetbad, scrub, voetverzorging, massage, warme
            voetcompressen inclusief lakken
          </li>
          <li>Thee naar keuze & versnaperingen</li>
          <li>90 min genieten met je vriendin, zus,…</li>
        </ul>
        <p>80 euro voor 2 personen (40 euro p.p)</p>
      </div>
      <img :src="duo1" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Duo Wellness</h2>
        <ul>
          <li>
            Yon-Ka Escale Beauté Gelaatsverzorging 30 min met reiniging, massage
            en masker
          </li>
          <li>Voetbad met voetscrub en massage 15 min</li>
          <li>Thee naar keuze & versnaperingen</li>
          <li>90 min genieten met je vriendin, zus,…</li>
        </ul>
        <p>90 euro voor 2 personen (45 euro p.p)</p>
      </div>
      <img :src="duo2" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Moeder en Kind</h2>
        <ul>
          <li>Manicure met lakken en handmassage voor mama en haar prinses</li>
          <li>
            Voetbad met Phytobain Yon-Ka voor mama, voetbad met een bruisbal
            voor haar prinses
          </li>
          <li>Voetmassage voor beide en teennagels lakken de prinses</li>
          <li>Yon-Ka intermezzo gelaatsverzorging van 15 min voor mama</li>
          <li>Thee, fruitsap en versnaperingen in thema</li>
          <li>
            Ook prinsen zijn welkom voor een arrangement in dinosaurusthema
          </li>
        </ul>
        <p>
          Geniet 70 min van een uniek mama kind moment omdat onze kinderen zo
          snel groot worden voor 70 euro
        </p>
      </div>
      <img :src="moederKind" alt="combo" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Zen Arrangementen</h2>
        <p>Voor lichamelijke en geestelijke ontspanning.</p>
      </div>
      <img :src="zen" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Zen</h2>
        <ul>
          <li>Yon-Ka intermezzo korte gelaatsverzorging 15 min</li>
          <li>
            Rugverzorging 25 min met scrub van de rug met warme compressen en
            rugmassage
          </li>
          <li>Warm voetbad met Yon-Ka Phytobain 10 min</li>
          <li>Thee voor rust en ontspanning</li>
          <li>
            Ademhalingsoefeningen, ontspanningstechnieken en begeleide meditatie
            oefening 15 min
          </li>
        </ul>
        <p>
          65 euro voor 65 min die volledig in het teken staan om jou te
          herbronnen
        </p>
      </div>
      <img :src="zen2" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Zen premium</h2>
        <ul>
          <li>
            Yon-Ka Escale Beauté gelaatsverzorging 30 min met reiniging, massage
            en masker
          </li>
          <li>
            Rugverzorging 30 min met scrub van de rug met warme compressen en
            rugmassage
          </li>
          <li>Warm voetbad met Yon-Ka Phytobain 10 min</li>
          <li>Thee voor rust en ontspanning</li>
          <li>
            Ademhalingsoefeningen, ontspanningstechnieken en begeleide meditatie
            oefening 15 min
          </li>
        </ul>
        <p>
          95 euro voor 90 min die volledig in het teken staan om jou te
          herbronnen.
        </p>
      </div>
      <img :src="zen1" alt="combo" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Combinatie</h2>
        <p>
          Wil je graag gecombineerde verzorgingen, dan kan je uiteraard meerdere
          verzorgingen samen boeken of kiezen uit 1 van onderstaande
          combinatie-arrangementen.
        </p>
      </div>
      <img :src="combo" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Relax 45min</h2>
        <ul>
          <li>
            Gelaatsverzorging Escale Beauté Yon-Ka (incl. reiniging, gommage,
            lotion, aangepaste verzorgende crème)
          </li>
          <li>Schouder en nekmassage</li>
          <li>Voetmassage</li>
          <li>Thee naar keuze</li>
        </ul>
        <p>45 min relaxen en ontsnappen uit de drukte voor 45 euro.</p>
      </div>
      <img :src="relax" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Relax, Cocoon & Wellness</h2>
        <ul>
          <li>
            Wellness gelaatsverzorging 60 min, ideaal wanneer je nood hebt aan
            een moment van absolute relaxatie. Deze hydraterende
            gelaatsverzorging heeft 2 massages en 2 exclusieve maskers.
          </li>
          <li>
            Relaxmassage van de rug met warme olie en etherische olien die je
            een ware cocoon-ervaring geven 20min.
          </li>
        </ul>
        <p>95 euro voor 80 minuten.</p>
      </div>
      <img :src="combo2" alt="combo" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Pedicure & gelaat</h2>
        <ul>
          <li>Wellness pedicure met lakken 45 min</li>
          <li>Intermezzo Yon-Ka kennismakingsgelaatsverzorging 15 min</li>
        </ul>
        <p>50 euro voor 60 minuten.</p>
      </div>
      <img :src="combo1" alt="combo" class="picHolder" />
    </div>
    <div class="lastPic leftTextArea">
      <div class="textHolder">
        <h2>Bride-2-be</h2>
        <ul>
          <li>Gelaatsverzorging hydrallessence voor een stralende huid</li>
          <li>
            Ontharing van 2 zones naar keuze uit wenkbrauwen, onderbenen,
            oksels, kin, bovenlip of bikinilijn
          </li>
          <li>Pedicure met lakken van de nagels</li>
          <li>Manicure</li>
        </ul>
        <p>155 euro voor 120 minuten.</p>
      </div>
      <img :src="bride2be" alt="combo" class="picHolder" />
    </div>
  </article>
</template>

<script>
import ArrAlgemeen from '../assets/ArrAlgemeen.webp';
import combo from '../assets/comboArr.webp';
import combo1 from '../assets/combo1.webp';
import combo2 from '../assets/combo2.webp';
import duo from '../assets/duoArr.webp';
import duo1 from '../assets/duo1.webp';
import duo2 from '../assets/duo2.webp';
import zen from '../assets/zenArr.webp';
import zen1 from '../assets/Zen1.webp';
import zen2 from '../assets/Zen2.webp';
import moederKind from '../assets/moederKind.webp';
import relax from '../assets/relax.webp';
import bride2be from '../assets/bride2be.webp';
export default {
  name: 'Arrangement',
  data() {
      return {
        ArrAlgemeen: ArrAlgemeen,
        combo: combo,
        combo1: combo1,
        combo2: combo2,
        duo: duo,
        duo1: duo1,
        duo2: duo2,
        zen: zen,
        zen1: zen1,
        zen2: zen2,
        moederKind: moederKind,
        relax: relax,
        bride2be: bride2be,
      }
    },
};
</script>

<style lang="scss" scoped>
</style>
